import React, { useContext } from 'react'
import { AppContext } from '../../../stores/application.store'
import OncePage from '../../pages/OncePage/OncePage';
import QuestionsPage from '../../pages/QuestionsPage/QuestionsPage';
import StartPage from '../../pages/StartPage/StartPage';
import ThankYou from '../../pages/ThankYouPage/ThankYou';
import Footer from '../Footer/Footer';

const Pageview = () => {
    const { pageView } = useContext(AppContext)!;
    return (
        <main>
            {pageView === "start" && <StartPage />}
            {pageView === "questions" && <QuestionsPage />}
            {pageView === "thank-you" && <ThankYou />}
            {pageView === "once" && <OncePage />}
            <Footer />
        </main>
    )
}

export default Pageview
